<template>
  <div class="service">
    <img class="bg" src="../../../assets/img/taiko/login/bg.png" alt="">
    <div class="title">
      <div class="white">联系客服</div>
    </div>
    <div class="mnp_code">
      <div class="mnp_code_2">
        <img :src="txCode" alt="">
        <div class="tips">
          长按识别图中二维码
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import txCode from 'assets/img/taiko/login/tx_code.png'
import parseQueryString from 'outils/parseQueryString'

export default {
  name: "service",
  data() {
    return {
      txCode:''
    };
  },
  mounted() {
    const query = parseQueryString(location.search)
    if(query.imgPath){
      this.txCode = query.imgPath
    }else{
      this.txCode = txCode
    }
  },
};
</script>

<style lang='scss' scoped>
@import "assets/scss/index.scss";
@import "./index.scss";
</style>